import {
    GET_LIVREURS,
    API_RESPONSE_SUCCESS,
    API_RESPONSE_ERROR,
  
    UPDATE_LIVREUR,
    UPDATE_LIVREUR_SUCCESS,
    UPDATE_LIVREUR_FAIL,
    
    ADD_NEW_LIVREUR,
    ADD_LIVREUR_SUCCESS,
    ADD_LIVREUR_FAIL,

  } from "./actionType";

  // common success
  export const livreurApiResponseSuccess = (actionType, data) => ({
    type: API_RESPONSE_SUCCESS,
    payload: { actionType, data },
  });
  // common error
  export const livreurApiResponseError = (actionType, error) => ({
    type: API_RESPONSE_ERROR,
    payload: { actionType, error },
  });
  
  export const getLivreurs = () => ({
    type: GET_LIVREURS,
  });

  export const updateLivreur = livreur => ({
    type: UPDATE_LIVREUR,
    payload: livreur,
  });
  
  export const updateLivreurSuccess = livreur => ({
    type: UPDATE_LIVREUR_SUCCESS,
    payload: livreur,
  });
  
  export const updateLivreurFail = error => ({
    type: UPDATE_LIVREUR_FAIL,
    payload: error,
  });
  
  export const addNewLivreur = livreur => ({
    type: ADD_NEW_LIVREUR,
    payload: livreur,
  });
  
  export const addLivreurSuccess = livreur => ({
    type: ADD_LIVREUR_SUCCESS,
    payload: livreur,
  });
  
  export const addLivreurFail = error => ({
    type: ADD_LIVREUR_FAIL,
    payload: error,
  });